// TODO: remove this file when centralized components between here and activities-desking are used
import type { ComponentProps, FC, ReactNode } from 'react';
import React from 'react';

// components
import DealSummaryItem from './DealSummaryItem';
import type { Typography } from '@interstate/components/Typography';

export interface IDealSummaryItemWrapperProps {
    children?: ReactNode;
    label: string;
    useWrapper?: boolean;
    value: string;
    showLargeValue?: boolean;
    isExpanded?: boolean;
    hasDelta?: boolean;
    valueStyles?: ComponentProps<typeof Typography>['sx'];
}

export const DealSummaryItemWrapper: FC<IDealSummaryItemWrapperProps> = ({
    children,
    label,
    useWrapper = true,
    value,
    showLargeValue,
    isExpanded,
    hasDelta = false,
    valueStyles
}) => {
    if (useWrapper) {
        return (
            <DealSummaryItem
                label={label}
                value={value}
                showLargeValue={showLargeValue}
                isExpanded={isExpanded}
                hasDelta={hasDelta}
                valueStyles={valueStyles}
            >
                {children}
            </DealSummaryItem>
        );
    } else {
        return <>{children}</>;
    }
};
